const pubsub = require('../utils/pubsub');

/**
 * subscribe all listed hooks in the config
 */
function init(hooks) {
	Object.keys(hooks).forEach((hook) => {
		add(hook, hooks[hook]);
	});
}

function _createLegacyHookPassthrough(hook) {
	window.dfp = window.dfp || {};

	if (typeof window.dfp[hook] === 'undefined') {
		window.dfp[hook] = (...args) => {
			pubsub.publish(hook, ...args);
		};
	}
}

function add(hook, callback) {
	pubsub.subscribe(hook, callback);

	_createLegacyHookPassthrough(hook);
}

module.exports = {
	init,
	add
};
